"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Online Training API
 * Online Training API documentation
 *
 * The version of the OpenAPI document: 0.0.81
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdvertiseApi = exports.AdvertiseApiFactory = exports.AdvertiseApiFp = exports.AdvertiseApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * AdvertiseApi - axios parameter creator
 * @export
 */
const AdvertiseApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Operation Id: GetCurrentAdvertise - Difficulty: 1 - Roles can execute: ROLE_CUSTOMER, ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Uygulamada gösterilecek reklam bilgilerini döndürür. CoverPhoto alanı IImageService\'te bulunan GetImageUrls metodu kullanılarak doldurulur. ContentJsonData veritabanındaki aynı isimdeki kolonun içeriğidir. Veritabanı sorgusu yapılırken id\'si en yüksek olan satırın içerikleri döndürülmelidir. Handler metodunda @Cacheable(\"advertise\") kullanılmalıdır.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentAdvertise: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/advertise/get_current_advertise`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.AdvertiseApiAxiosParamCreator = AdvertiseApiAxiosParamCreator;
/**
 * AdvertiseApi - functional programming interface
 * @export
 */
const AdvertiseApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.AdvertiseApiAxiosParamCreator)(configuration);
    return {
        /**
         * Operation Id: GetCurrentAdvertise - Difficulty: 1 - Roles can execute: ROLE_CUSTOMER, ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Uygulamada gösterilecek reklam bilgilerini döndürür. CoverPhoto alanı IImageService\'te bulunan GetImageUrls metodu kullanılarak doldurulur. ContentJsonData veritabanındaki aynı isimdeki kolonun içeriğidir. Veritabanı sorgusu yapılırken id\'si en yüksek olan satırın içerikleri döndürülmelidir. Handler metodunda @Cacheable(\"advertise\") kullanılmalıdır.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentAdvertise(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCurrentAdvertise(options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.AdvertiseApiFp = AdvertiseApiFp;
/**
 * AdvertiseApi - factory interface
 * @export
 */
const AdvertiseApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.AdvertiseApiFp)(configuration);
    return {
        /**
         * Operation Id: GetCurrentAdvertise - Difficulty: 1 - Roles can execute: ROLE_CUSTOMER, ROLE_SUPER_ADMIN, ROLE_ADMIN
         * @summary Uygulamada gösterilecek reklam bilgilerini döndürür. CoverPhoto alanı IImageService\'te bulunan GetImageUrls metodu kullanılarak doldurulur. ContentJsonData veritabanındaki aynı isimdeki kolonun içeriğidir. Veritabanı sorgusu yapılırken id\'si en yüksek olan satırın içerikleri döndürülmelidir. Handler metodunda @Cacheable(\"advertise\") kullanılmalıdır.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentAdvertise(options) {
            return localVarFp.getCurrentAdvertise(options).then((request) => request(axios, basePath));
        },
    };
};
exports.AdvertiseApiFactory = AdvertiseApiFactory;
/**
 * AdvertiseApi - object-oriented interface
 * @export
 * @class AdvertiseApi
 * @extends {BaseAPI}
 */
class AdvertiseApi extends base_1.BaseAPI {
    /**
     * Operation Id: GetCurrentAdvertise - Difficulty: 1 - Roles can execute: ROLE_CUSTOMER, ROLE_SUPER_ADMIN, ROLE_ADMIN
     * @summary Uygulamada gösterilecek reklam bilgilerini döndürür. CoverPhoto alanı IImageService\'te bulunan GetImageUrls metodu kullanılarak doldurulur. ContentJsonData veritabanındaki aynı isimdeki kolonun içeriğidir. Veritabanı sorgusu yapılırken id\'si en yüksek olan satırın içerikleri döndürülmelidir. Handler metodunda @Cacheable(\"advertise\") kullanılmalıdır.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdvertiseApi
     */
    getCurrentAdvertise(options) {
        return (0, exports.AdvertiseApiFp)(this.configuration).getCurrentAdvertise(options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AdvertiseApi = AdvertiseApi;
